import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import { getLocalStorageLang } from '@/service/local-cache/localStorage';
import { E_Lang } from '@/apis/service/types';
Vue.use(VueI18n);
const locale = getLocalStorageLang();
let i18n;
export async function getI18n() {
    let results = [];
    const langTask = (() => {
        switch (locale) {
            case E_Lang.cn: return import('./locales/importCn');
            case E_Lang.en: return import('./locales/importEn');
        }
    })();
    if (langTask) {
        results = await langTask.then(({ message }) => Promise.all(message));
    }
    const message = results.reduce((obj, data) => {
        return _.merge(obj, data);
    }, {});
    i18n = new VueI18n({
        locale,
        messages: _.merge({}, { [locale]: message }),
        fallbackLocale: E_Lang.en,
    });
    return i18n;
}
export function getLocale() {
    return i18n ? i18n.locale : E_Lang.en;
}
